import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/04bbe0155b757389228720afc786ad63.js')["default"];

var scope_1 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/06de31bc600a78f9d8020aab048d194a.js')["default"];

var scope_2 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_3 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/204af51642405e6d11267af6f062a3a9.js')["default"];

var scope_4 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/21947658fe2dcb29ef94c27d3105386c.js')["default"];

var scope_5 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/250ae764b6036a92e6da46e4353a49ee.js')["default"];

var scope_6 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2a197fd5a9a74465053ddcb1326f7416.js')["default"];

var scope_7 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/41e714cd52a8e0e2270311ca63c58e45.js')["default"];

var scope_8 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/458ce5439d3918f2d015822648115834.js')["default"];

var scope_9 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/517a9f3be12ce3886423f0bba354fbad.js')["default"];

var scope_10 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5fc089b81d48875dd545fd0e44c6040b.js')["default"];

var scope_11 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6748b87f7c587a7068a3fb2de4f095bd.js')["default"];

var scope_12 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8dbac48c37b57dcffa9a7f1db9e37e61.js')["default"];

var scope_13 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e203dbeeb5635af73c6dfafdbff0751.js')["default"];

var scope_14 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a014f9b5552c27ee9135f4372f1dd7db.js')["default"];

var scope_15 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/afb53c22a2d0441ce2cbb6fa47df50d7.js')["default"];

var scope_16 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b4c7705015be9151a37be496ea1f6374.js')["default"];

var scope_17 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c23c3cdcd46b9e2cf54e890fcb08a228.js')["default"];

var scope_18 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c3e5d4a84ee9cab2aa79ea7c9556798a.js')["default"];

var scope_19 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d26f8de098874df0638473b23e59354e.js')["default"];

var scope_20 = require('/home/travis/build/emcasa/ui/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e8d20ef83ec37a55c16d0cfbadc035c9.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19, scope_20);